<template>
    <div v-if="visible" class="overlay" @click="hide">
      <!-- <div class="overlay-content">{{ message }}</div> -->
       <img :src="imgUrl" alt="">
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        visible: false,
        message: '',
        imgUrl:''
      };
    },
    methods: {
      show(msg) {
        //this.message = msg;
        this.imgUrl = msg;
        this.visible = true;
      },
      hide() {
        this.visible = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 9999; 
    padding: 100px;
  }
  .overlay-content {
    color: white;
    font-size: 24px;
  }
  img{
     
      height: 120px
  }
  </style>
  